import React from 'react';
import { Zap, Brain, Heart, Star, CheckCircle } from 'lucide-react';
export function ProblemSolution() {
  return <section className="py-16 px-4 md:px-8 lg:px-16 bg-white" data-id="element-253">
      <div className="max-w-7xl mx-auto" data-id="element-254">
        <div className="text-center mb-16" data-id="element-255">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-indigo-900" data-id="element-256">
            ¿Te Sientes Atrapado En Una Energía Que No Te Permite Avanzar?
          </h2>
          <p className="text-lg md:text-xl text-gray-700 max-w-3xl mx-auto" data-id="element-257">
            La mayoría de las personas viven toda su vida en frecuencias
            energéticas bajas que les impiden manifestar abundancia, salud y
            relaciones plenas. La verdad es que...
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 mb-16" data-id="element-258">
          <div className="bg-red-50 p-8 rounded-lg border border-red-200" data-id="element-259">
            <h3 className="text-2xl font-bold mb-4 text-red-700" data-id="element-260">
              Si te identificas con esto...
            </h3>
            <ul className="space-y-4" data-id="element-261">
              {['Te sientes estancado, sin importar cuánto te esfuerces', 'Experimentas ansiedad o pensamientos negativos recurrentes', 'La abundancia parece esquivarte constantemente', 'Tus relaciones te drenan en lugar de nutrirte', 'Sientes que hay un potencial dentro de ti que no logras liberar'].map((item, index) => <li key={index} className="flex items-start" data-id="element-262">
                  <span className="text-red-500 mr-2 mt-1" data-id="element-263">✖</span>
                  <span data-id="element-264">{item}</span>
                </li>)}
            </ul>
          </div>
          <div className="bg-green-50 p-8 rounded-lg border border-green-200" data-id="element-265">
            <h3 className="text-2xl font-bold mb-4 text-green-700" data-id="element-266">
              Con 30 Días Frecuencia Prohibida...
            </h3>
            <ul className="space-y-4" data-id="element-267">
              {['Elevarás tu frecuencia vibratoria a un nivel nunca antes experimentado', 'Desbloquearás tu capacidad innata para manifestar tus deseos', 'Transformarás patrones limitantes en impulsos de crecimiento', 'Atraerás relaciones y oportunidades alineadas con tu nueva energía', 'Vivirás desde un estado de claridad, poder y propósito'].map((item, index) => <li key={index} className="flex items-start" data-id="element-268">
                  <CheckCircle size={20} className="text-green-500 mr-2 mt-1" data-id="element-269" />
                  <span data-id="element-270">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
        <div className="text-center mb-12" data-id="element-271">
          <h3 className="text-2xl md:text-3xl font-bold mb-6 text-indigo-900" data-id="element-272">
            La Solución: Un Sistema Probado Para Elevar Tu Frecuencia Vibratoria
          </h3>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto" data-id="element-273">
            30 Días Frecuencia Prohibida es el único programa que combina
            sabiduría ancestral con ciencia moderna para desbloquear tu
            verdadero potencial energético.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-274">
          {[{
          icon: <Zap size={40} className="text-indigo-600" data-id="element-275" />,
          title: 'Energía Vibrante',
          description: 'Accede a frecuencias que elevan tu campo energético y te permiten manifestar desde un estado superior'
        }, {
          icon: <Brain size={40} className="text-indigo-600" data-id="element-276" />,
          title: 'Claridad Mental',
          description: 'Elimina la niebla mental y accede a un estado de concentración y creatividad sin precedentes'
        }, {
          icon: <Heart size={40} className="text-indigo-600" data-id="element-277" />,
          title: 'Conexión Auténtica',
          description: 'Atrae relaciones que reflejan tu nueva vibración y potencian tu crecimiento personal'
        }].map((benefit, index) => <div key={index} className="bg-indigo-50 p-6 rounded-lg text-center hover:shadow-lg transition-all" data-id="element-278">
              <div className="flex justify-center mb-4" data-id="element-279">{benefit.icon}</div>
              <h4 className="text-xl font-bold mb-2 text-indigo-900" data-id="element-280">
                {benefit.title}
              </h4>
              <p className="text-gray-700" data-id="element-281">{benefit.description}</p>
            </div>)}
        </div>
      </div>
    </section>;
}